// FIREBASE
import firebase from 'keys/firebase'

// STORAGE
import 'firebase/storage'

// INSTANCIA
const storage: firebase.storage.Storage = firebase.storage()

// REFERENCIA
const ref = storage.ref()

// OBTENER IMAGENES
const getImage = (path: string) => {
	// REFERENCIA
	const imageRef = ref.child(`gallery/${path}`)

	// OBTENER URL
	return imageRef.getDownloadURL()
}

export default storage
export { getImage }
